import React from "react";
import AppIcon from './AppIcon.jsx'

const AppCollapse = ({ 
  title, 
  subtitle, 
  border = true, 
  children,
  defaultOpen = false,
  arrowPosition = "right",
  rightButtons,
  backgroundColor = "white",
  onToggle=()=>{}
}) => {
  const [open, setOpen] = React.useState(defaultOpen);
  
  const getBackgroundColorClass = () => {
    if (backgroundColor === "white") return "bg-white";
    if (backgroundColor === "gray") return "bg-gray-50";
    if (backgroundColor === "blue") return "bg-blue-50";
    // Allow custom color classes
    return backgroundColor.startsWith("bg-") ? backgroundColor : `bg-${backgroundColor}`;
  };

  const renderArrow = () => {
    const rotation = open ? "rotate-180" : "rotate-0";
    
    return (
      <span
        className={`inline-flex transform transition-transform duration-300 ${rotation}`}
      >
        <AppIcon 
          name="arrowDown" 
          size={24}
        />
      </span>
    );
  };

  const toggleCollapse = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((prevOpen) => {
      const nextOpen = !prevOpen;
      if (nextOpen) {
        onToggle?.();
      }
      return nextOpen;
    });
  }

  React.useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <div className={`${border && 'border border-gray-200 rounded-xl'} ${getBackgroundColorClass()}`}>
      {/* Header */}
      <div className="w-full flex items-center p-4">
        {/* Left Arrow */}
        {arrowPosition === "left" && (
          <button
            type="button"
            onClick={(e) => toggleCollapse(e)}
            className="mr-3 flex-shrink-0 cursor-pointer flex items-center justify-center"
          >
            {renderArrow()}
          </button>
        )}

        {/* Title Section */}
        <div
          type="button"
          onClick={(e) => toggleCollapse(e)}
          className={`flex-1 cursor-pointer flex items-center justify-between text-left ${arrowPosition === "left" ? "" : "w-full"}`}
        >
          <div className="flex-1 flex flex-col gap-2">
            <h3 className="font-semibold text-gray-900" style={{margin: 0}}>{title}</h3>
            {subtitle && (
              <p className="text-sm text-gray-500" style={{margin: 0}}>{subtitle}</p>
            )}
          </div>

          {/* Right Arrow */}
          {arrowPosition === "right" && !rightButtons && (
            <div className="ml-3 flex-shrink-0 flex items-center">
              {renderArrow()}
            </div>
          )}
        </div>

        {/* Right Buttons */}
        {rightButtons && (
          <div className="ml-3 flex items-center gap-2 flex-shrink-0">
            {rightButtons}
            {arrowPosition === "right" && (
              <button
                type="button"
                onClick={(e) => toggleCollapse(e)}
                className="ml-2 cursor-pointer"
              >
                {renderArrow()}
              </button>
            )}
          </div>
        )}
      </div>

      {/* Content */}
      <div
        className={`grid transition-all duration-300 ease-in-out ${ "grid-rows-[1fr] opacity-100"}`}
      >
        {
          open &&   
           <div className="overflow-hidden px-4 pb-2">
            {children}
            </div>
        }
       
      </div>
    </div> 
  );
};

export default AppCollapse;
